import type { ProdottoCarrello, GruppoProdotti, ProdottoCheckout, CodicePromo } from '~/utils/checkout'

export const useCarrelloStore = defineStore('carrello', {
    state: () => {
        return {
            items: <ProdottoCarrello[]>[],
            codicePromo: <CodicePromo | null>null,
            calcoloPrezzoInCorso: <boolean>false
        }
    },
    getters: {
        gruppiProdotti: (state): GruppoProdotti[] => {
            return [...new Map(state.items.map(item => [`${item.tipo == 'carte_regalate' ? 'carte' : item.tipo}${item.id}`, {
                id: item.id,
                tipo: item.tipo == 'carte_regalate' ? 'carte' : item.tipo,
                dettaglio: item.dettaglio,
                prezzoSingolo: item.prezzo,
                prezzoTotale: (item.tipo == 'carte' || item.tipo == 'carte_regalate') ? state.items.filter((i) => (i.tipo == 'carte' || i.tipo == 'carte_regalate') && i.id == item.id).reduce((acc, i) => acc + i.prezzo, 0) : state.items.filter((i) => i.tipo == item.tipo && i.id == item.id).reduce((acc, i) => acc + i.prezzo, 0),
                prezzoScontato: (item.tipo == 'carte' || item.tipo == 'carte_regalate') ? state.items.filter((i) => (i.tipo == 'carte' || i.tipo == 'carte_regalate') && i.id == item.id).reduce((acc, i) => acc + (i.prezzo_gruppo || 0), 0) : state.items.filter((i) => i.tipo == item.tipo && i.id == item.id).reduce((acc, i) => acc + (i.prezzo_gruppo || 0), 0),
                oggetti: (item.tipo == 'carte' || item.tipo == 'carte_regalate') ? state.items.filter((i) => (i.tipo == 'carte' || i.tipo == 'carte_regalate') && i.id == item.id) : state.items.filter((i) => i.tipo == item.tipo && i.id == item.id),
                combo: (item.tipo == 'carte' || item.tipo == 'carte_regalate') ? state.items.filter((i) => (i.tipo == 'carte' || i.tipo == 'carte_regalate') && i.id == item.id).some((i) => i.prezzo_combo && !isNaN(i.prezzo_combo)) || false : state.items.filter((i) => i.tipo == item.tipo && i.id == item.id).some((i) => i.prezzo_combo && !isNaN(i.prezzo_combo)) || false,
            }])).values()]
        },
        prezzoCalcolato: (state): number => {
            if (state.calcoloPrezzoInCorso) return 0
            return [...new Map(state.items.map(item => [`${item.tipo == 'carte_regalate' ? 'carte' : item.tipo}${item.id}`, {
                prezzoTotale: (item.tipo == 'carte' || item.tipo == 'carte_regalate') ? state.items.filter((i) => (i.tipo == 'carte' || i.tipo == 'carte_regalate') && i.id == item.id).reduce((acc, i) => acc + i.prezzo, 0) : state.items.filter((i) => i.tipo == item.tipo && i.id == item.id).reduce((acc, i) => acc + i.prezzo, 0)
            }])).values()].reduce((acc, item) => acc + item.prezzoTotale, 0)
        },
        prezzoCalcolatoScontato: (state): number => {
            if (state.calcoloPrezzoInCorso) return 0
            return [...new Map(state.items.map(item => [`${item.tipo == 'carte_regalate' ? 'carte' : item.tipo}${item.id}`, {
                prezzoScontato: (item.tipo == 'carte' || item.tipo == 'carte_regalate') ? state.items.filter((i) => (i.tipo == 'carte' || i.tipo == 'carte_regalate') && i.id == item.id).reduce((acc, i) => acc + (i.prezzo_gruppo || 0), 0) : state.items.filter((i) => i.tipo == item.tipo && i.id == item.id).reduce((acc, i) => acc + (i.prezzo_gruppo || 0), 0)
            }])).values()].reduce((acc, item) => acc + item.prezzoScontato, 0)
        },
        gruppiCheckout: (state): ProdottoCheckout[] => {
            return [...new Map(state.items.map(item => {
                const id = `
                    ${item.tipo}
                    ${item.id}
                    ${item.email ? item.email : ''}
                    ${item.intestatario && item.intestatario.first_name ? item.intestatario && item.intestatario.first_name : ''}
                    ${item.intestatario && item.intestatario.last_name ? item.intestatario && item.intestatario.last_name : ''}
                    ${item.intestatario && item.intestatario.data_di_nascita ? item.intestatario && item.intestatario.data_di_nascita : ''}
                    ${item.data ? item.data : ''}
                    ${item.tariffa ? item.tariffa : ''}
                    ${item.accessorio ? item.accessorio.sort().toString() : ''}
                    ${item.convenzione ? item.convenzione : ''}
                    ${item.lingua ? item.lingua : ''}
                `

                let quantita = state.items.filter((i) => (i.tipo == item.tipo && i.id == item.id)).length
                if (item.tipo == 'carte_regalate') quantita = state.items.filter((i) => (i.tipo == item.tipo && i.id == item.id && i.email == item.email)).length
                if (item.tipo == 'abbonamenti_athena') quantita = state.items.filter((i) => (i.tipo == item.tipo && i.id == item.id && i.intestatario?.first_name == item.intestatario?.first_name && i.intestatario?.last_name == item.intestatario?.last_name && i.intestatario?.data_di_nascita == item.intestatario?.data_di_nascita && i.convenzione == item.convenzione)).length
                if (item.tipo == 'visite_guidate') quantita = state.items.filter((i) => (i.tipo == item.tipo && i.id == item.id && i.data == item.data && i.tariffa == item.tariffa && i.accessorio?.sort().toString() == item.accessorio?.sort().toString() && i.convenzione == item.convenzione && i.lingua == item.lingua)).length

                return [id, {
                    id: item.id,
                    tipo: item.tipo,
                    quantita: quantita,
                    email: item.email || null,
                    data: item.data || null,
                    tariffa: item.tariffa || null,
                    intestatario: item.intestatario || null,
                    accessorio: item.accessorio || null,
                    convenzione: item.convenzione || null,
                    lingua: item.lingua
                }]
            })).values()]
        },
    },
    actions: {
        aggiungiOggetto(oggetto: ProdottoCarrello) {
            this.items.push(oggetto)
            this.calcolaPrezzi()
        },
        rimuoviOggetto(key: string, ricalcola = true) {
            const index = this.items.findIndex((i) => i.key == key);
            if (index > -1) {
                this.items.splice(index, 1)
            }
            if (ricalcola === true) {
                this.calcolaPrezzi()
            }
        },

        aggiungiProdottoAGruppo(gruppo: GruppoProdotti) {
            const tipo = gruppo.tipo == 'carte' || gruppo.tipo == 'carte_regalate' ? 'carte' : gruppo.tipo

            this.aggiungiOggetto({
                key: Date.now().toString(36) + Math.floor(Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12)).toString(36),
                id: gruppo.id,
                tipo: tipo,
                dettaglio: gruppo.dettaglio,
                prezzo: gruppo.prezzoSingolo
            })
        },
        rimuoviProdottoDaGruppo(gruppo: GruppoProdotti) {
            if (gruppo.oggetti.length > 1) {
                const ultimaKey = gruppo.oggetti[gruppo.oggetti.length - 1].key
                this.rimuoviOggetto(ultimaKey)
            }
        },
        rimuoviGruppo(gruppo: GruppoProdotti) {
            for (const oggetto of gruppo.oggetti) {
                this.rimuoviOggetto(oggetto.key, false)
            }
            this.calcolaPrezzi()
        },

        applicaCodicePromo(codice: CodicePromo) {
            this.codicePromo = codice

            this.calcolaPrezzi()
        },
        rimuoviCodicePromo() {
            this.codicePromo = null

            this.calcolaPrezzi()
        },

        async calcolaPrezzi() {
            const { api } = useRuntimeConfig().public

            if (this.items && Array.isArray(this.items) && this.items.length > 0) {
                try {
                    this.calcoloPrezzoInCorso = true

                    const prodottiPrezzati = await $fetch(`${api}checkout/prezzo/carrello`, {
                        method: 'POST',
                        body: JSON.stringify({ prodotti: this.items?.map((p: ProdottoCarrello) => ({ ...p, quantita: 1 })), codice: this.codicePromo?.codice || null }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })

                    if (prodottiPrezzati && Array.isArray(prodottiPrezzati)) {
                        this.items = prodottiPrezzati
                    }

                    this.calcoloPrezzoInCorso = false
                } catch (error) {
                    console.log(error)
                    this.calcoloPrezzoInCorso = false
                }
            } else {
                this.calcoloPrezzoInCorso = false
            }
        },

        resetCarrello() {
            this.items = []
            this.codicePromo = null
            this.calcolaPrezzi()
        }
    },
    persist: {
        storage: piniaPluginPersistedstate.localStorage(),
    }
})